<template>
  <v-dialog v-model="visible" max-width="600" persistent>
    <v-card>
      <v-card-title class="headline error lighten-2">
        {{ errorCode }}
      </v-card-title>

      <v-card-text class="pa-6">
        {{ message }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn :href="$route.fullPath" color="error" text>
            โหลดใหม่อีกครั้ง
          </v-btn>
          <v-btn href="/" color="success" text>
            กลับหน้าหลัก
          </v-btn>
          <v-btn href="/login" color="primary" text>
            ออกจากระบบ
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    visible() {
      return this.$store.state.error.visible
    },
    errorCode() {
      return this.$store.state.error.errorCode || 'ระบบขัดข้อง'
    },
    message() {
      return (
        this.$store.state.error.message ||
        'เกิดข้อผิดพลาดในระบบ กรุณารอสักครู่แล้วเข้าใช้งานอีกครั้ง'
      )
    }
  },
  watch: {
    visible() {
      if (this.errorCode === 403) {
        this.$store.commit('error/set_error_visible', {
          visible: false,
          errorCode: '',
          message: ''
        })
        this.$router.push('/')
      }
    }
  }
}
</script>
